import { useUserStore } from "../store/userStore";

/**
 * Hook to get the current user's subscription tier
 * Returns: 'free' | 'basic' | 'pro'
 */
export const useUserTier = () => useUserStore((s) => s.userTier);
